<template lang="pug">
.modal-card(style="width: auto")  
  header.modal-card-head
    p.modal-card-title Rechnung

  section.modal-card-body(v-if="settings")
    //- pre {{ data }}
    b-tabs(v-if="data[0]" @input="e => activeOwner = +e" :destroy-on-hide="true")
      b-tab-item(v-for="(d, idx) in data" active :label="d.fullName" :value="''+idx")
        ValidationObserver(ref="form")
          .generic-wrapper
            .container
              .two-column
                .column
                  h2.title.is-6 E-Mail Anhang
                  iframe(ref="pdf-preview").pdf-preview
                .column
                  .form.w640(v-if="formDataArray[idx] && formDataArray[idx].subject")
                    h2.title.is-6 E-Mail schreiben
                    ValidationProvider(name="E-Mail Betreff" rules="required" v-slot="{ errors, valid }")
                      b-field(label="E-Mail Betreff" label-position="on-border"
                        :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                        b-input(v-model="formDataArray[idx].subject")
                    ValidationProvider(name="E-Mail Text" rules="required" v-slot="{ errors, valid }") 
                      b-field(label="E-Mail Text" label-position="on-border"
                        :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                        vue-editor(v-model="formDataArray[idx].body" :editorOptions="editorOptions")
              //- .spacer.sm
              //- .form.w640(v-if="settings.canOverridePaymentReminderDueDays")
              //-   h2.title.is-6 Einstellungsmöglichkeiten
              //-   b-message(v-if="!formData.dueDate" type="is-danger" has-icon) Bitte wählen Sie eine Mahnungsfälligkeit aus, um eine PDF-Vorschau zu sehen.
              //-   v-date-picker(:value='formData.dueDate' @dayclick="d => updateDueDate(d)" :popover="popoverConfig" :min-date='new Date()')
              //-     template(v-slot='{ inputValue, inputEvents }')
              //-       b-field(:label="escalationLevel === 1 ? 'Erinnerungsfälligkeit' : 'Mahnungsfälligkeit'" label-position="on-border")
              //-         input.dt-selection-date(:value='formData.dueDate ? formatDate(formData.dueDate) : null' v-on='inputEvents')
              //-       .disclaimer(v-if="formData.dueDate") Der Gast hat somit <b>{{dueDateGuestTime === 1 ? dueDateGuestTime + ' Tag' : dueDateGuestTime + ' Tage'}}</b> Zeit, um auf die Mahnung zu reagieren.


  footer.modal-card-foot
    button.button.is-light(@click="$emit('close')") Abbrechen
    button.button.is-secondary(@click="create()") Speichern ohne Senden
    button.button.is-primary(@click="create('sendEmail')") Senden & Speichern
</template>

<script>
import { DateTime } from 'luxon';

export default {
  props: {
    data: {
      type: Array,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      activeOwner: 0,
      settings: null,
      popoverConfig: {
        visibility: 'focus'
      },
      formDataArray: [],
      editorOptions: {
        placeholder: "Bitte füllen Sie dieses Feld aus ...",
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike", "link"], // toggled buttons
            ["blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ align: [] }],
            ["clean"] // remove formatting button
          ]
        }
      }
    };
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    this.settings = await this.$store.dispatch("settings/find");

    for (let i = 0; i < this.data.length; i += 1) {
      const { subject, body } = await this.generateEmail(i, this.data[i].type);
      this.formDataArray.push({
        subject,
        body
      });
    }
    this.generatePDF(this.activeOwner);
    loadingComponent.close();
  },
  watch: {
    activeOwner(newVal) {
      this.generatePDF(newVal);
    }
  },
  methods: {
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.toLocaleString({
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      });
    },
    updateDueDate(newVal) {
      const dueDate = DateTime.fromJSDate(newVal.date).set({ hour: 23, minute: 59 });
      this.formData.dueDate = dueDate.toISO();
      // this.generateEmail();
      // this.generatePDF();
    },
    async generateEmail(idx, type) {
      const emailTemplates = await this.$store.dispatch("emailTemplates/findAll");
      if (type === 'financeInvoice-owner') {
        let reminderTemplate = emailTemplates.find(e => e.uuid === `FINANCE_INVOICE_OWNER_EMAIL`); // based on escalation level we show the correct template
        const result = await this.$store.dispatch("emailTemplates/replaceTemplateValues", { template: reminderTemplate, booking: { owner: this.data[idx] } });
        return { subject: result.template.subject, body: result.template.body }
      } else {
        let reminderTemplate = emailTemplates.find(e => e.uuid === `FINANCE_INVOICE_CUSTOMER_EMAIL`); // based on escalation level we show the correct template
        const result = await this.$store.dispatch("emailTemplates/replaceTemplateValues", { template: reminderTemplate, booking: this.data[idx] });
        return { subject: result.template.subject, body: result.template.body }
      }
    },
    async generatePDF(idx) {
      const loadingComponent = this.$buefy.loading.open();

      // Here as well we show the preview of the respective escalation level
      const pdfArraybuffer = await this.$store.dispatch(`financeInvoices/PDFPreview`, { ...this.formDataArray[idx], ...this.data[idx] });
      const pdfBlob = new Blob([pdfArraybuffer], { type: "application/pdf" });
      this.$refs["pdf-preview"][0].src = URL.createObjectURL(pdfBlob);

      loadingComponent.close();
    },
    async create(sendEmail) {
      const loadingComponent = this.$buefy.loading.open();
      for (let i = 0; i < this.data.length; i++) {
        await this.$store.dispatch("financeInvoices/create", { ...this.formDataArray[i], ...this.data[i], sendEmail });
        if (this.data.length >= 2) {
          this.$buefy.toast.open(`Rechnung erstellt für ${this.data[i].firstName} ${this.data[i].lastName}`);
        }
      }
      loadingComponent.close();
      this.$router.push('/finances/invoices');
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss" scoped>
.two-column {
  display: flex;
  justify-content: space-between;
}

.pdf-preview {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 280px);
}
</style>